<script>
  import PopupService from '../../../../domain/popup/services/popup'
  import {VueMaskDirective as mask} from 'v-mask'
  import moment from 'moment'

  export default {
    name: 'popups',
    directives: {mask},
    data () {
      return {
        popups: [],
        isLoading: false,
        isDeleting: false
      }
    },
    computed: {
    },
    filters: {
      dataHora (value) {
        return moment(value).format('L LT')
      }
    },
    mounted () {
      this.getPopupsList()
    },
    activated () {
    },
    destroyed () {
    },
    methods: {
      getPopupsList () {
        this.isLoading = true
        PopupService.getPopupsList()
          .then(result => {
            this.popups = result.data
            this.isLoading = false
          })
          .catch(error => {
            this.isLoading = false
            console.log(error.response.data.errors)
          })
      },
      deletePopup (id, index) {
        this.isDeleting = true
        PopupService.deletePopup(id)
          .then(result => {
            console.log('excluiu')
            this.popups.splice(index, 1)
            this.isDeleting = false
          })
          .catch(error => {
            console.log('deu erro', error.response.data.errors)
            this.isDeleting = false
          })
      },
      loading (v) {
        this.isLoading = !!v
      },

      nextElement ({target}) {
        let index = parseInt(target.getAttribute('tabindex'))
        let next = index + 1
        document.querySelector('[tabindex="' + next + '"').focus()
      }
    }
  }
</script>

<template>
  <div>
    <div class="app-content-body ">
      <div class="bg-light lter b-b wrapper-md">
        <h1 class="m-n font-thin h3">Pop-ups</h1>
      </div>
      <span class="info-msg" v-if="isDeleting">Excluindo...</span>
      <div class="wrapper-md">
        <div class="panel panel-default">
          <div>
            <div class="table-responsive">
              <div id="DataTables_Table_0_wrapper" class="dataTables_wrapper form-inline dt-bootstrap no-footer">
                <div class="row">
                  <div class="col-md-6 col-sm-6 col-xs-6">
                    <div class="dataTables_length" id="DataTables_Table_0_length">
                      <label>Mostrar
                        <select name="DataTables_Table_0_length" aria-controls="DataTables_Table_0" class="form-control input-sm">
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select> resultados
                      </label>
                    </div>
                  </div>
                  <div class="col-md-6 col-sm-6 col-xs-6">
                    <div id="DataTables_Table_0_filter" class="dataTables_filter">
                      <label style="float: right;">Pesquisar:
                        <input type="search" class="form-control input-sm" placeholder="" aria-controls="DataTables_Table_0">
                      </label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <table ui-jq="dataTable" class="table table-striped b-t b-b dataTable no-footer" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
                      <thead>
                      <tr role="row">
                        <th style="width: 185px;" class="sorting_asc" tabindex="0" aria-controls="DataTables_Table_0" rowspan="1" colspan="1" aria-sort="ascending">Thumb</th>
                        <th style="width: 185px;" class="sorting_asc" tabindex="0" aria-controls="DataTables_Table_0" rowspan="1" colspan="1" aria-sort="ascending" aria-label="Rendering engine: activate to sort column descending">Nome</th>
                        <th style="width: 239px;" class="sorting" tabindex="0" aria-controls="DataTables_Table_0" rowspan="1" colspan="1" aria-label="Platform(s): activate to sort column ascending">Situação</th>
                        <th style="width: 250px;" class="sorting" tabindex="0" aria-controls="DataTables_Table_0" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending">Data Exibição</th>
                        <th style="width: 250px;" class="sorting" tabindex="0" aria-controls="DataTables_Table_0" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending">Data Expiração</th>
                        <th style="width: 100px;" class="sorting" tabindex="0" aria-controls="DataTables_Table_0" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending">Ação</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-if="isLoading">
                        <td colspan="6"><div class="m-t m-b text-center"><i class="fa fa-spinner fa-spin"></i> </div></td>
                      </tr>
                      <tr v-else-if="popups.length < 1">
                        <td colspan="6"><div class="m-t m-b text-center">Não há popups cadastrados</div></td>
                      </tr>
                      <tr class="odd" v-for="(popup, index) in popups" :key="popup.id" v-else>
                        <td class="dataTables_empty v-middle text-center">
                          <img :src="popup.imageInfo.thumb.url" alt="popup-thumb" v-if="popup.imageInfo" lazy="loading" height="80">
                          <span v-else>-</span>
                        </td>
                        <td class="dataTables_empty v-middle">{{ popup.nome }}</td>
                        <td class="dataTables_empty v-middle">
                          <label class="btn btn-sm w-xs" :class="{ 'btn-success': popup.situacao, 'btn-danger': !popup.situacao }">{{ popup.situacao ? 'Ativo' : 'Inativo' }}</label>
                        </td>
                        <td class="dataTables_empty v-middle">{{ popup.dataExibicao.date | dataHora }}</td>
                        <td class="dataTables_empty v-middle">{{ popup.dataExpiracao.date | dataHora }}</td>
                        <td class="dataTables_empty v-middle">
                          <div class="row m-b-xs m-r-xs action-btn">
                            <!--div class="col-md-4">
                              <a class="btn btn-default" ui-toggle-class="button">
                                <i class="fa icon-cloud-upload text"></i>
                                <i class="fa icon-cloud-upload text-active text-danger"></i>
                              </a>
                            </div-->
                            <div class="col-md-6">
                              <router-link :to="{ name: 'popup.edit', params: { id: popup.id } }" class="btn btn-default" ui-toggle-class="button">
                                <i class="glyphicon glyphicon-edit"></i>
                              </router-link>
                            </div>
                            <div class="col-md-6">
                              <a class="btn btn-default" ui-toggle-class="button" href="javascript:;" @click="deletePopup(popup.id, index)">
                                <i class="glyphicon glyphicon-trash"></i>
                              </a>
                            </div>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite">Mostrando de {{ popups.length > 0 ? '1' : '0' }} até {{ popups.length }} de {{ popups.length }} registros</div>
                  </div>
                  <div class="col-sm-6">
                    <div class="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate">
                      <ul class="pagination" style="float: right;">
                        <li class="paginate_button previous disabled" aria-controls="DataTables_Table_0" tabindex="0" id="DataTables_Table_0_previous">
                          <a href="#">Anterior</a>
                        </li>
                        <li class="paginate_button next disabled" aria-controls="DataTables_Table_0" tabindex="0" id="DataTables_Table_0_next">
                          <a href="#">Próximo</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .info-msg {
    background-color: khaki;
    padding: 5px 15px;
    display: block;
    text-align: center;
  }
  .action-btn {
    display: flex;
  }
</style>



// WEBPACK FOOTER //
// Popups.vue?aa9de0ae